var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-cy":"main-layout"}},[_c('app-navigation'),_c('app-bar',{attrs:{"loading":_vm.$ui.isLoading}}),_c('v-main',[_c('app-main-prepend'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }